
export default function ToggleSideNavDirective() {
    return {
        template: require('./toggle-mobile.directive.html'),
        transclude: true,
        restrict: 'E',
        controller: function ($scope, navService) {

            'ngInject';
            
            $scope.class = function () {
                return navService.isShowingSideNav() ? "is-active" : "";
            };

            $scope.click = function () {
                navService.toggleSideNav();
            };
        },
    };
}
